import $ from "jquery";
import Cookies from "js-cookie";
import { Resource } from "jsonapi-js";
import constants from "../../shared/constants";
import serverConstants from "../../../../server/lib/constants";
import cache from "../../shared/cache";
import ajaxError from "../../shared/actions/ajaxError";
import validDates from "../../shared/utils/validDates";

const {
  FETCH_PARTNER_ACTIVITIES,
  FETCH_PARTNER_ACTIVITIES_DONE,
  FETCH_BOOKMARK_LISTS,
  CREATE_BOOKMARK,
  CREATE_BOOKMARK_DONE,
  CREATE_LIST,
} = constants;

function initPoi() {
  return {
    type: constants.INIT_POI,
  };
}

function fetchNextDone({ pois, next }) {
  return {
    type: constants.FETCH_NEXT_DONE,
    data: { pois, next },
  };
}

function fetchBookmarkListsDone(lists) {
  return {
    type: constants.FETCH_BOOKMARK_LISTS_DONE,
    data: lists,
  };
}

function fetchNext(id, poiType, resource, url = "") {
  const data = {};

  if (url) {
    data.resource = url;
  }

  return (dispatch) => {
    $.ajax({
      data,
      contentType: "application/json",
    }).done((pois) => {
      dispatch(fetchNextDone({
        pois: Resource.from(pois),
        next: pois.links.next,
      }));
    });

    dispatch({
      type: constants.FETCH_NEXT,
    });
  };
}

function fetchPoiDone(poi) {
  // Add to cache
  cache.set(poi.id, poi);

  return {
    type: constants.FETCH_POI_DONE,
    data: poi,
  };
}

function fetchPoi({ id }) {
  return (dispatch) => {
    const url = location.pathname;

    dispatch({
      type: constants.FETCH_POI,
    });

    if (cache.has(id)) {
      dispatch(fetchPoiDone(cache.get(id)));
    } else {
      $.ajax({
        url,
        contentType: "application/json",
      }).done((poi) => {
        dispatch(fetchPoiDone((poi)));
      })
      .fail((response, status) => {
        dispatch(ajaxError(url, status));
        dispatch(fetchPoiDone({}));
      });
    }
  };
}

function poiUnmount() {
  return {
    type: constants.POI_UNMOUNT,
  };
}

function fetchAvailabilityDone(data) {
  return {
    type: constants.FETCH_AVAILABILITY_DONE,
    data,
  };
}

function fetchAvailability({
  id,
  startDate,
  endDate,
  numNights,
}) {
  return (dispatch) => {
    const url = `/${serverConstants.AJAX_PATH}/lodgings/availability`;

    if (!validDates(startDate, endDate)) {
      Cookies.remove("availability");

      return dispatch({
        type: constants.AVAILABILITY_ERROR,
        data: {
          startDate,
          endDate,
          message: "Invalid dates",
        },
      });
    }

    Cookies.set("availability", {
      startDate,
      endDate,
      numNights,
    });

    $.ajax({
      url,
      data: {
        id, fromDate: startDate, toDate: endDate,
      },
    })
    .done((data) => dispatch(fetchAvailabilityDone(data)))
    .fail((response, status) => {
      dispatch(ajaxError(url, status));
      dispatch(fetchAvailabilityDone([]));
    });

    return dispatch({
      type: constants.FETCH_AVAILABILITY,
      data: {
        startDate,
        endDate,
        numNights,
      },
    });
  };
}


function fetchPartnerActivitiesDone(id, items) {
  return {
    type: FETCH_PARTNER_ACTIVITIES_DONE,
    data: {
      id,
      partnerActivities: items,
    },
  };
}

function fetchPartnerActivities({ id, placeId }) {
  return (dispatch) => {
    $.ajax({
      url: `/a/pois/${id}/partner-activities?placeId=${placeId}`,
      contentType: "application/json",
    }).done((pois) => {
      if (pois) {
        dispatch(fetchPartnerActivitiesDone(id, pois));
      }
    });

    dispatch({
      type: FETCH_PARTNER_ACTIVITIES,
    });
  };
}


function fetchBookmarkLists({
  userId,
}) {
  return (dispatch) => {
    $.ajax({
      url: `${window.lp.hosts.profile}/profile/api/${userId}/lists`,
      contentType: "application/json",
      xhrFields: {
        withCredentials: true,
      },
      headers: {
        accept: "application/json",
      },
    }).done((response) => {
      if (response) {
        dispatch(fetchBookmarkListsDone(response));
      }
    });

    dispatch({
      type: FETCH_BOOKMARK_LISTS,
    });
  };
}

const createBookmarkAjax = ({
  bookmark,
  userId,
  listId,
}) => $.ajax({
  url: bookmark.id ?
  `${window.lp.hosts.profile}/profile/api/${userId}/lists/${listId}/entries/${bookmark.id}` :
  `${window.lp.hosts.profile}/profile/api/${userId}/lists/${listId}/entries`,
  contentType: "application/json",
  method: bookmark.id ? "PATCH" : "POST",
  data: JSON.stringify(bookmark),
  headers: {
    accept: "application/json",
  },
  xhrFields: {
    withCredentials: true,
  },
});

const createListAjax = ({
  list,
  userId,
}) => $.ajax({
  url: `${window.lp.hosts.profile}/profile/api/${userId}/lists`,
  contentType: "application/json",
  method: "POST",
  data: JSON.stringify(list),
  headers: {
    accept: "application/json",
  },
  xhrFields: {
    withCredentials: true,
  },
});

function createBookmark({
  bookmark,
  list,
  userId,
}) {
  return (dispatch) => {
    if (!list.id) {
      createListAjax({
        list,
        userId,
      }).done((newList) => {
        dispatch(fetchBookmarkListsDone({
          lists: [newList],
        }));

        createBookmarkAjax({
          bookmark,
          userId,
          listId: newList.id,
        }).done((newBookmark) => {
          if (newBookmark) {
            dispatch({
              type: CREATE_BOOKMARK_DONE,
              data: newBookmark,
            });

            dispatch(fetchBookmarkLists({
              userId,
            }));
          }
        });

        dispatch({
          type: CREATE_BOOKMARK,
          data: bookmark,
        });
      });

      dispatch({
        type: CREATE_LIST,
      });
      return;
    }

    createBookmarkAjax({
      bookmark,
      userId,
      listId: list.id,
    }).done((newBookmark) => {
      dispatch({
        type: CREATE_BOOKMARK_DONE,
        data: newBookmark,
      });

      dispatch(fetchBookmarkLists({
        userId,
      }));
    });

    dispatch({
      type: CREATE_BOOKMARK,
      data: bookmark,
    });

    return;
  };
}

export {
  fetchNext,
  fetchNextDone,
  fetchPoi,
  fetchPoiDone,
  poiUnmount,
  initPoi,
  fetchAvailability,
  fetchAvailabilityDone,
  fetchPartnerActivities,
  fetchBookmarkLists,
  createBookmark,
};



// WEBPACK FOOTER //
// ./assets/pois/actions/pois.js